import { AlertCircle, Ban, CheckCircle, ClipboardCheck, Clock, FileText, Undo2, XCircle } from 'lucide-react';
import { Badge } from '../../ui/badge';
import { getActualStatus } from '../../work-permits/constants';

const MAP = {
  aktif: ['bg-emerald-100 text-emerald-700', CheckCircle, 'Onaylandı'],
  eksik_hatali: ['bg-rose-600 text-white', AlertCircle, 'Eksik/Hatalı'],
  talep_bilgisi_hatali: ['bg-fuchsia-600 text-white', AlertCircle, 'Talep Bilgisi Hatalı'],
  onay_bekliyor: ['bg-indigo-100 text-indigo-700', Clock, 'Onay Bekliyor'],
  isg_inceleme: ['bg-sky-100 text-sky-700', ClipboardCheck, 'İSG İncelemesinde'],
  red_edildi: ['bg-rose-100 text-rose-700', XCircle, 'Reddedildi'],
  geri_cekildi: ['bg-slate-200 text-slate-700', Undo2, 'Geri Çekildi / İptal'],
  suresi_dolmus: ['bg-amber-100 text-amber-800', Ban, 'Süresi Dolmuş'],
  tamamlandi: ['bg-slate-100 text-slate-600', CheckCircle, 'Tamamlandı'],
};

export const StoreStatusBadge = ({ permit }) => {
  const s = ['geri_cekildi', 'iptal'].includes(permit.status) ? 'geri_cekildi' : getActualStatus(permit);
  const [cls, Icon, label] = MAP[s] || ['bg-slate-100 text-slate-600', FileText, s];
  return <Badge className={`${cls} flex w-fit items-center gap-1 whitespace-nowrap`} data-testid={`incoming-status-${permit.id}`}><Icon className="h-3 w-3" />{label}</Badge>;
};
